<rt-dialog-body layout layout-justify-center>
  <div layout-vertical layout-align-items-center margin-small>
    <div class="img-wrap" layout-centered margin-tb-medium>
      <img [src]="imageSrc" alt="" />
    </div>
    <div margin-tb layout-vertical layout-align-items-center>
      <rt-heading variant="heading large-xx dark">
        {{ message }}
      </rt-heading>
      <rt-heading variant="subheading">
        {{ description }}
      </rt-heading>
    </div>
    <div layout-full-width layout-centered>
      <rt-button
        *ngFor="let button of buttons; let isLast = last; trackBy: trackByValue"
        variant
        [variant]="button.variant"
        [href]="button.href || null"
        [hrefTarget]="button.hrefTarget || null"
        [attr.margin-right-small]="!isLast"
        (click)="close(button)"
      >
        <rt-icon *ngIf="button.icon" [name]="button.icon"></rt-icon>
        {{ button.text }}
      </rt-button>
    </div>
  </div>
</rt-dialog-body>
